module.exports = __webpack_public_path__ + "img/civilization.f41b33cd.png";